<form class="email-notifications" [formGroup]="form" (ngSubmit)="saveNotificationSettings(form)">
	<div class="content">
		<span class="content-header" translate="account-settings-panel_email-notifications"></span>
		<span *ngIf="user.email"
			class="content-subheader with-email"
			translate="account-settings-panel_email-notification-text"
			[translateParams]="{email: user.email}"></span>

		<section class="content-body">
			<ng-container *ngIf="user.email">
				<mat-form-field class="assignment-submitted-email-frequency-field" appearance="outline" *ngIf="assignment_submitted_email_frequency && hasReviewerRoleOrHigher()">
					<mat-label translate="account-settings-panel_unviewed-assignment-submissions"></mat-label>
					<mat-select
						formControlName="assignment_submitted_email_frequency"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let frequency of frequenciesNotImmediately"
							[value]="frequency">
							{{ frequency.name }}
						</mat-option>
					</mat-select>
					<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
				</mat-form-field>

				<mat-form-field class="feedback-submitted-email-frequency-field" appearance="outline" *ngIf="feedback_submitted_email_frequency">
					<mat-label translate="account-settings-panel_unviewed-feedback"></mat-label>
					<mat-select
						formControlName="feedback_submitted_email_frequency"
						disableOptionCentering
						panelClass="offsetPanel">
						<mat-option
							*ngFor="let frequency of frequenciesNotImmediately"
							[value]="frequency">
							{{ frequency.name }}
						</mat-option>
					</mat-select>
					<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
				</mat-form-field>

				<ng-container *ngIf="hasPresenterRole()">
					<mat-form-field class="new-assignment-email-frequency-field" appearance="outline" *ngIf="new_assignment_email_frequency">
						<mat-label translate="account-settings-panel_new-assignment"></mat-label>
						<mat-select
							formControlName="new_assignment_email_frequency"
							disableOptionCentering
							panelClass="offsetPanel">
							<mat-option
								*ngFor="let frequency of frequenciesNotImmediately"
								[value]="frequency">
								{{ frequency.name }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>

					<mat-form-field class="assignment-due-email-frequency-field" appearance="outline" *ngIf="assignment_due_email_frequency && !isLti()">
						<mat-label translate="account-settings-panel_assignment-due"></mat-label>
						<mat-select
							formControlName="assignment_due_email_frequency"
							disableOptionCentering
							panelClass="offsetPanel">
							<mat-option
								*ngFor="let frequency of frequenciesNotWeekly"
								[value]="frequency">
								{{ frequency.name }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>

					<mat-form-field class="assignment-graded-email-frequency-field" appearance="outline" *ngIf="assignment_graded_email_frequency">
						<mat-label translate="account-settings-panel_assignment-graded"></mat-label>
						<mat-select
							formControlName="assignment_graded_email_frequency"
							disableOptionCentering
							panelClass="offsetPanel">
							<mat-option
								*ngFor="let frequency of frequenciesNotHourly"
								[value]="frequency">
								{{ frequency.name }}
							</mat-option>
						</mat-select>
						<mat-icon matIconSuffix class="ficon-app-chevron-down"></mat-icon>
					</mat-form-field>
				</ng-container>
			</ng-container>
		</section>
	</div>

	<div class="content-footer" *ngIf="shouldShowSaveButton$ | async">
		<button
			class="primary-btn submit-btn"
			type="submit"
			translate="common_save-changes">
		</button>
	</div>
</form>
